const global = window

inputs.types.text = function (data, name, niceName, type, input, parent, inputWindow) {
    if (data.type == 'slug') {
        input.change(function() {
            inputFilename(input)
        })
        input.keyup(function() {
            inputFilename(input)
        })
    }
    return data
}
